import { view } from '@yola/ws-sdk';
import deviceModeWidths from 'src/js/modules/view/constants/device-mode-widths';
import MODES from './modes';

export default {
  [MODES.desktop]: { width: 1280, height: 720 },
  [MODES.tablet]: { width: deviceModeWidths[view.deviceModes.TABLET], height: 1024 },
  [MODES.mobile]: { width: deviceModeWidths[view.deviceModes.MOBILE], height: 812 },
};
